import DatricRequests from '../datric.requests';
import { CreateUserPayload, UpdateLeilaoPayload, UpdateUserPayload, User } from '../../../models/user.model';

const requests = new DatricRequests();

export async function listUsers(): Promise<User[]> {
	return requests.get('users');
}

export async function createUser(payload: CreateUserPayload): Promise<User> {
	return requests.post('users', payload);
}

export async function getUser(id: string): Promise<User> {
	return requests.get(`users/${id}`);
}

export async function updateUser(id: string, payload: UpdateUserPayload): Promise<User> {
	return requests.patch(`users/${id}`, payload);
}

export async function updateUserPrice(id: string, pricePerQuery: number): Promise<User> {
	return requests.patch(`users/${id}/price`, { pricePerQuery });
}

export async function updateUserLeilao(id: string, payload: UpdateLeilaoPayload): Promise<User> {
	return requests.patch(`users/${id}/leilao`, payload);
}

// Reset pelo ADMIN sobre outro usuário.
export async function setUserPassword(id: string, newPassword: string): Promise<{ success: boolean }> {
	return requests.patch(`users/${id}/password`, { newPassword });
}

// Troca da própria senha, disponível para qualquer papel.
export async function changeMyPassword(currentPassword: string, newPassword: string): Promise<{ success: boolean }> {
	return requests.patch('me/password', { currentPassword, newPassword });
}

export async function addUserCredits(id: string, amount: number, description?: string): Promise<any> {
	return requests.post(`users/${id}/credits`, { amount, description });
}

export async function setUserActive(id: string, active: boolean): Promise<User> {
	return requests.patch(`users/${id}/active`, { active });
}

// Exclusão lógica no servidor: o histórico do usuário é preservado.
export async function deleteUser(id: string): Promise<{ success: boolean }> {
	return requests.delete(`users/${id}`);
}
